<template>
	<div style="height: 100%">
		<div class="sa-flexbox" style="padding-bottom: 20px">
			<div class="sa-flexbox-body">
				<div class="b-table-sticky-header">
					<b-table sticky-header ref="table" :selectable="selectable" @row-selected="onRowSelected"
						stacked="xl" striped hover select-mode="multi" :items="items" :fields="fields"
						:current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light"
						class="sa-b-table">
						<template #cell(index)="row">
							{{ (currentPage - 1) * perPage + row.index + 1 }}
						</template>
						<template v-slot:cell(cognomeRagioneSoggetto)="{ item }">{{ item.cognomeRagioneSoggetto }} {{
							item.nomeSoggetto }}</template>
						<template #cell(tipo)="row">
							{{ getIconaTipologiaOperazione(row.item) }}

						</template>
						<template #cell(actions)="row">
							<b-container class="bv-example-row" v-if="actions">
								<b-button size="sm"
									variant="btn btn-outline-primary waves-effect waves-light width-sm no-text"
									:placeholder="'Visualizza Documento'" style="margin-right: 5px"
									@click="onViewDocumento(row)">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button size="sm"
									variant="btn btn-outline-purple waves-effect waves-light width-sm no-text"
									style="margin-right: 5px" @click="onStampa(row.item)">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button size="sm" variant="btn btn-outline-info no-text"
									@click="onDownload(row.item)">
									<b-icon icon="download"></b-icon>
								</b-button>
							</b-container>
						</template>
					</b-table>
				</div>
			</div>
			<div class="sa-list-component-footer">
				<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col lg="3">
						<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
					</b-col>
					<b-col lg="9">
						<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
							size="sm"></b-pagination>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	props: {
		selectable: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
		quantitaZeroNotVisible: {
			type: Boolean,
			required: false,
			default: () => {
				return false;
			},
		},
		actions: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
	},
	data() {
		return {
			currentPage: 1,
			rows: 0,
			perPage: 100,
			pathResource: "/contabilitadocumenti",
			items: [],
			documentiCollegati: [],
			fields: [
				{
					label: "N.",
					key: "index",
					thStyle: "width: 3rem",
				},
				{
					label: "",
					key: "tipo",
					thStyle: "width: 1rem",
				},
				{
					label: "Data Documento",
					key: "documentoData",
					sortable: true,
					thStyle: "width: 7rem",
					formatter: (value) => {
						return moment(new Date(value)).format("DD-MM-YYYY");
					},
				},
				{
					label: "Num.",
					key: "documentoNumero",
					thStyle: "width: 5rem",
					sortable: true,
				},
				{
					label: "Tipo Documento",
					key: "tipoDocumentoDescrizione",
					// thStyle: "width: 14rem",
					sortable: true,
				},
				{
					label: "Causale Documento",
					key: "causaleDocumentoDescrizione",
					// thStyle: "width: 14rem",
					sortable: true,
				},
				{
					label: "Ragione Sociale",
					key: "soggettoCognomeRagione",
					sortable: true,
				},
				{
					label: "Data Creazione",
					key: "createDate",
					sortable: true,
					thStyle: "width: 7rem",
					formatter: (value) => {
						return moment(new Date(value)).format("DD-MM-YYYY");
					},
				},
				{
					label: "Totale",
					key: "documentoTotale",
					sortable: true,
					formatter: (value) => {
						if (value) {
							value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
						} else if (value === 0) {
							value = value.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
						}
						return value;
					},
					thStyle: "width: 7rem",
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		refresh(filter) {
			let me = this;
			me.loadData(filter);
		},
		loadData(filtroDocumenti) {
			let me = this;
			this.openShowModalLoading();
			UtilityMixin.methods.loadDataResources(me.pathResource, filtroDocumenti, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			this.closeShowModalLoading();
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			error;
			this.closeShowModalLoading();
			me.$emit("afterLoadData");
		},
		setDocumentiCollegati(documentiCollegati) {
			this.documentiCollegati = documentiCollegati;
		},
		isRowActiveForDocumentoCollegati(row) {
			console.log("this.documentiCollegati", this.documentiCollegati);

			let a = this.documentiCollegati.filter((e) => e.idDocumentoRiferimento == row.item.id);
			console.log(a);
		},
		getIconaTipologiaOperazione(item) {
			console.log(item);

		},



		onViewDocumento(row) {
			//TODO CAMBIARE PUNTAMENTO DEVE ESSERE /view/
			this.$router.push("/contabilita/documenti/edit/" + row.item.id);
		},
		onRowSelected(array) {
			this.$emit("rowSelected", array);
		},
	},
};
</script>

<style></style>
